import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import {
  DashboardStoreReviewIndexQuerySchema,
  StoreReviewSortSchema,
  StoreReviewStatusSchema
} from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// DashboardStoreReviewIndexRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [
    { field: 'status', options: StoreReviewStatusSchema.options },
    { field: 'sort', options: StoreReviewSortSchema.options }
  ]
})

export const DashboardStoreReviewIndex = (_context: NoContext = {}) =>
  z.preprocess(normalize, DashboardStoreReviewIndexQuerySchema)
